import { saferPromise } from '../../../lib/promise-utils'

const checkResponseOk = res => {
  if (res.status !== 200) {
    throw Error()
  }
  return res
}

const saferFetchOpts = {
  attempts: 3,
  delay: [2000, 5000],
  timeout: 15000
}

const commonFetch = async url => {
  const res = await fetch(url)
  const isOk = checkResponseOk(res)
  if (!isOk) throw Error('Request failed')
  return res.json()
}

export async function safelyFetchNews(url) {
  const validate = json => {
    // const { flow, universe, newsFeed } = json

    if (!json.flow && !json.universe && !json.newsFeed) {
      throw Error('Data missing')
    }

    return json
  }

  return saferPromise(() => commonFetch(url).then(validate), saferFetchOpts)
}

export async function safelyFetchSchedule(url) {
  const validate = json => {
    const { matches } = json

    if (!matches || !matches.length) {
      throw Error('Data missing')
    }
    return matches
  }

  return saferPromise(() => commonFetch(url).then(validate), saferFetchOpts)
}

export async function safelyFetchGroups(url) {
  const validate = json => {
    const { groups } = json
    if (!groups || !groups.length) {
      throw Error('Data missing')
    }
    return groups
  }

  return saferPromise(() => commonFetch(url).then(validate), saferFetchOpts)
}

export async function safelyFetchMatch(url) {
  const validate = json => {
    const { matches } = json
    if (!matches || !matches.length || !matches[0]) {
      throw Error('Data missing')
    }
    return matches[0]
  }

  return saferPromise(() => commonFetch(url).then(validate), saferFetchOpts)
}

export async function safelyFetchRefetch(url) {
  const validate = json => {
    const { matches, scheduleMatches } = json

    if (!matches || !matches.length || !matches[0]) {
      throw Error('Data missing')
    }

    if (!scheduleMatches || !scheduleMatches.length) {
      throw Error('Data missing')
    }

    return { match: matches[0], scheduleMatches }
  }

  return saferPromise(() => commonFetch(url).then(validate), saferFetchOpts)
}

export async function safelyFetchClipsAndPlaylists(url) {
  const validate = json => {
    const { playlists, clips } = json

    if (!playlists || !playlists.length) {
      throw Error('Data missing')
    }

    if (!clips || !clips.length) {
      throw Error('Data missing')
    }

    return { playlists, clips }
  }

  return saferPromise(() => commonFetch(url).then(validate), saferFetchOpts)
}
